/**
 * PERFIL TÉCNICO DA MEDIÇÃO DE ESPESSURA EM ALTA TEMPERATURA.
 *
 * Só a faixa de temperatura em que uma medição é tratada como "alta
 * temperatura" vive aqui (60 °C a 550 °C) — o ME e o catálogo
 * (`me-thermal-correction.ts`) leem daqui, para que o limite não fique
 * espalhado pelo código.
 *
 * @deprecated (parcial) Este perfil já teve parâmetros do MÉTODO B removido
 * (N-2371: tolerância de espessura da calibração, medições por verificação,
 * método de correção). O MÉTODO A — RESULTADO APROXIMADO não usa nenhum
 * parâmetro de calibração: Vsa, k e a Temperatura de Referência vêm do
 * Procedimento (NdtProcedure) vinculado ao relatório, nunca deste perfil.
 */
export interface HotThicknessProfile {
  readonly id: string;
  /** Acima deste valor (estrito) a medição é de alta temperatura. */
  readonly highTemperatureMinC: number;
  /** Máximo coberto pelo perfil. */
  readonly highTemperatureMaxC: number;
}

/** Acima de 60 °C até 550 °C a medição é tratada como alta temperatura. */
export const HOT_THICKNESS_PROFILE_N2371: HotThicknessProfile = {
  id: "ME-HIGH-TEMPERATURE",
  highTemperatureMinC: 60,
  highTemperatureMaxC: 550
};
